import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const FooterLicenseWidget = () => {
  const { t } = useTranslation();
  useEffect(() => {
    //@ts-ignore
    // anj_bf9a6ca3_1ee7_4a71_86e3_df4074e42087.init();
  }, []);
  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <h3 className="partners__heading">{t("footer.license")}</h3>
      <div
        style={{ width: "46px", display: "inline-block" }}
        id="anj-bf9a6ca3-1ee7-4a71-86e3-df4074e42087"
        data-anj-seal-id="bf9a6ca3-1ee7-4a71-86e3-df4074e42087"
        data-anj-image-size="128"
        data-anj-image-type="basic-small"
      >
        <a
          href="https://verification.anjouangaming.org/validate?domain=enomo.casino&seal_id=10acce43d5ecb6ef7c7cfaa7953108b6f6f478b3a25b70e326b81e4f6c5b50ab10c89dd2242ae578c4c2c5fc10662726&stamp=da67a62041e77356f6c44bbd398ffdf3"
          target="blank"
          referrerPolicy="no-referrer"
        >
          <img
            src={`https://${process.env.REACT_APP_IMAGE_DOMAIN}/license/anjuan.png`}
            alt="Anjuan License Verified"
          />
        </a>
      </div>
    </Box>
  );
};
